module.exports = __webpack_public_path__ + "img/full3-min.daca6eb3.png";